
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("UVBHs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8af96d4db8e9c97f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $8af96d4db8e9c97f$export$2e2bcd8739ae039 = {
    'ai-summary-label': 'Summarise',
    'copy-content-link-label': 'Copy link',
    'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Start typing to search for a label',
    'dynamic-cards-search-page.app-filter-sidebar.all': 'All',
    'dynamic-cards-search-page.app-filter-sidebar.group': 'Filter search by product',
    'dynamic-cards-search-page.atlas.for': 'for',
    'dynamic-cards-search-page.avatar': 'Avatar',
    'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Calendar',
    'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Join meeting',
    'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Meeting link',
    'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Join meeting',
    'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Past events',
    'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Recurring event',
    'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Recurring',
    'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Upcoming events',
    'dynamic-cards-search-page.compass.owner-name': 'Owned by {ownerName}',
    'dynamic-cards-search-page.compass.state': '{state}',
    'dynamic-cards-search-page.compass.tier': 'Tier {tier}',
    'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Find content',
    'dynamic-cards-search-page.confluence.filter.content.selected': 'Selected',
    'dynamic-cards-search-page.confluence.filter.content.unselected': 'Suggested',
    'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Selected',
    'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Suggested',
    'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Find people',
    'dynamic-cards-search-page.confluence.filter.label.selected': 'Selected',
    'dynamic-cards-search-page.confluence.filter.label.unselected': 'Suggested',
    'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Find labels',
    'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Find spaces',
    'dynamic-cards-search-page.connect_third_party_product_description': 'Connect your account to see missing results',
    'dynamic-cards-search-page.connect_third_party_product_title': 'Your admin has added {product}!',
    'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} is now available!',
    'dynamic-cards-search-page.date.filter.after.label': 'after',
    'dynamic-cards-search-page.date.filter.any.time': 'Anytime',
    'dynamic-cards-search-page.date.filter.before.label': 'before',
    'dynamic-cards-search-page.date.filter.custom': 'Custom',
    'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'The From date has to be before the To date',
    'dynamic-cards-search-page.date.filter.custom.invalid.after.today': "The From date can\u2019t be in the future",
    'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': "The To date can\u2019t be in the future",
    'dynamic-cards-search-page.date.filter.from.title': 'From',
    'dynamic-cards-search-page.date.filter.input.placeholder': 'Choose a date',
    'dynamic-cards-search-page.date.filter.last.month': 'Past 30 days',
    'dynamic-cards-search-page.date.filter.last.week': 'Past 7 days',
    'dynamic-cards-search-page.date.filter.last.year': 'Past year',
    'dynamic-cards-search-page.date.filter.title': 'Last updated',
    'dynamic-cards-search-page.date.filter.to.range': 'to',
    'dynamic-cards-search-page.date.filter.to.title': 'To',
    'dynamic-cards-search-page.date.filter.today': 'Today',
    'dynamic-cards-search-page.date.filter.update.button': 'Update',
    'dynamic-cards-search-page.date.filter.yesterday': 'Yesterday',
    'dynamic-cards-search-page.design-search-result.label': 'Design',
    'dynamic-cards-search-page.document-search-result.google-docs-label': 'Docs',
    'dynamic-cards-search-page.document-search-result.google-sheets-label': 'Sheets',
    'dynamic-cards-search-page.document-search-result.google-slides-label': 'Slides',
    'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
    'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
    'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
    'dynamic-cards-search-page.dropdown_generate_answer': 'Generate answer',
    'dynamic-cards-search-page.dropdown_recent_icon_label': 'Recent',
    'dynamic-cards-search-page.dropdown_search': 'Search',
    'dynamic-cards-search-page.dropdown_search_icon_label': 'Search',
    'dynamic-cards-search-page.error_primary': "We're having trouble searching",
    'dynamic-cards-search-page.error_secondary': 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
    'dynamic-cards-search-page.externalPeopleLabel': 'External people #{channelName}',
    'dynamic-cards-search-page.externalPersonLabel': 'External person',
    'dynamic-cards-search-page.filter.clear.filter.label': 'Clear filter',
    'dynamic-cards-search-page.filter.last.updated.anytime': 'Anytime',
    'dynamic-cards-search-page.filter.last.updated.costum': 'Custom',
    'dynamic-cards-search-page.filter.last.updated.past30Days': 'Past 30 days',
    'dynamic-cards-search-page.filter.last.updated.past7Days': 'Past 7 days',
    'dynamic-cards-search-page.filter.last.updated.pastYear': 'Past year',
    'dynamic-cards-search-page.filter.last.updated.today': 'Today',
    'dynamic-cards-search-page.filter.last.updated.yesterday': 'Yesterday',
    'dynamic-cards-search-page.filter.type.all': 'All',
    'dynamic-cards-search-page.filter.type.answer': 'Answers',
    'dynamic-cards-search-page.filter.type.attachment': 'Attachments',
    'dynamic-cards-search-page.filter.type.blogpost': 'Blog posts',
    'dynamic-cards-search-page.filter.type.board': 'Board',
    'dynamic-cards-search-page.filter.type.branch': 'Branches',
    'dynamic-cards-search-page.filter.type.calendar': 'Calendars',
    'dynamic-cards-search-page.filter.type.card': 'Card',
    'dynamic-cards-search-page.filter.type.comment': 'Comments',
    'dynamic-cards-search-page.filter.type.commit': 'Commits',
    'dynamic-cards-search-page.filter.type.component': 'Components',
    'dynamic-cards-search-page.filter.type.conversation': 'Conversations',
    'dynamic-cards-search-page.filter.type.database': 'Databases',
    'dynamic-cards-search-page.filter.type.design': 'Designs',
    'dynamic-cards-search-page.filter.type.documents': 'Documents',
    'dynamic-cards-search-page.filter.type.embed': 'Smart Links',
    'dynamic-cards-search-page.filter.type.folder': 'Folders',
    'dynamic-cards-search-page.filter.type.goal': 'Goals',
    'dynamic-cards-search-page.filter.type.issue': 'Issues',
    'dynamic-cards-search-page.filter.type.message': 'Messages',
    'dynamic-cards-search-page.filter.type.page': 'Pages',
    'dynamic-cards-search-page.filter.type.placeholder': 'Find type',
    'dynamic-cards-search-page.filter.type.presentation': 'Presentations',
    'dynamic-cards-search-page.filter.type.project': 'Projects',
    'dynamic-cards-search-page.filter.type.pull-request': 'Pull requests',
    'dynamic-cards-search-page.filter.type.question': 'Questions',
    'dynamic-cards-search-page.filter.type.repository': 'Repositories',
    'dynamic-cards-search-page.filter.type.space': 'Spaces',
    'dynamic-cards-search-page.filter.type.space-calendar': 'Space calendars',
    'dynamic-cards-search-page.filter.type.spreadsheet': 'Spreadsheets',
    'dynamic-cards-search-page.filter.type.tag': 'Tags',
    'dynamic-cards-search-page.filter.type.video': 'Videos',
    'dynamic-cards-search-page.filter.type.web-page': 'Web pages',
    'dynamic-cards-search-page.filter.type.whiteboard': 'Whiteboards',
    'dynamic-cards-search-page.filter.type.work-item': 'Work items',
    'dynamic-cards-search-page.filters.clear-all-button-label': 'Clear all',
    'dynamic-cards-search-page.filters.dropdown.clear-all': 'Clear all',
    'dynamic-cards-search-page.filters.dropdown.title': 'Filter',
    'dynamic-cards-search-page.filters.names.assignee': 'Assignee',
    'dynamic-cards-search-page.filters.names.content': 'Content under',
    'dynamic-cards-search-page.filters.names.contributor': 'Contributor',
    'dynamic-cards-search-page.filters.names.labels': 'Label',
    'dynamic-cards-search-page.filters.names.owner': 'Owner',
    'dynamic-cards-search-page.filters.names.project': 'Project',
    'dynamic-cards-search-page.filters.names.space': 'Space',
    'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Title match',
    'dynamic-cards-search-page.filters.names.type': 'Type',
    'dynamic-cards-search-page.filters.names.verified': 'Verified',
    'dynamic-cards-search-page.github-branch-result.label': 'Branch',
    'dynamic-cards-search-page.github-commit-result.label': 'Commit',
    'dynamic-cards-search-page.github-pull-request-result.label': 'Pull request',
    'dynamic-cards-search-page.input_clear_icon_label': 'Clear',
    'dynamic-cards-search-page.input_placeholder': 'Search or ask anything',
    'dynamic-cards-search-page.input_placeholder_search_only': 'Search anything',
    'dynamic-cards-search-page.input_search_icon_label': 'Search',
    'dynamic-cards-search-page.jira.filter.assignee.placeholder': 'Find people',
    'dynamic-cards-search-page.jira.filter.assignee.selected': 'Selected',
    'dynamic-cards-search-page.jira.filter.assignee.unselected': 'Suggested',
    'dynamic-cards-search-page.jira.filter.project.placeholder': 'Find projects',
    'dynamic-cards-search-page.jira.filter.project.selected': 'Selected',
    'dynamic-cards-search-page.jira.filter.project.unselected': 'Suggested',
    'dynamic-cards-search-page.landing_primary': 'Get started with filters for dynamic cards',
    'dynamic-cards-search-page.landing_secondary': 'Define your rules to automatically build cards',
    'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Docs',
    'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Slides',
    'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Sheets',
    'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
    'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
    'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
    'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
    'dynamic-cards-search-page.no_results_primary': "We couldn't find anything matching your search",
    'dynamic-cards-search-page.no_results_secondary_some_filters_applied': 'Looks like you have some filters applied. You could try clearing them.',
    'dynamic-cards-search-page.nouns.goal': 'Goal',
    'dynamic-cards-search-page.nouns.goals': 'Goals',
    'dynamic-cards-search-page.nouns.project': 'Project',
    'dynamic-cards-search-page.nouns.projects': 'Projects',
    'dynamic-cards-search-page.nouns.tag': 'Tag',
    'dynamic-cards-search-page.nouns.tags': 'Tags',
    'dynamic-cards-search-page.number_of_results': 'Showing {numberOfResults, number} of {totalCount, number} results',
    'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Authorisation for {product} failed.',
    'dynamic-cards-search-page.oauth-banner.authorization-success': 'Authorisation for {product} successful.',
    'dynamic-cards-search-page.oauth-message-connect': 'Connect',
    'dynamic-cards-search-page.oauth-message-dismiss': 'Dismiss',
    'dynamic-cards-search-page.products.custom-website': 'Web page',
    'dynamic-cards-search-page.products.custom-websites': 'Web pages',
    'dynamic-cards-search-page.results-sort.createdDate.selected': 'Sort by created (newest)',
    'dynamic-cards-search-page.results-sort.createdDateASC': 'Created (oldest)',
    'dynamic-cards-search-page.results-sort.createdDateASC.selected': 'Sort by created (oldest)',
    'dynamic-cards-search-page.results-sort.createdDateDESC': 'Created (newest)',
    'dynamic-cards-search-page.results-sort.latestModifiedDateASC': 'Updated (oldest)',
    'dynamic-cards-search-page.results-sort.latestModifiedDateASC.selected': 'Sort by updated (oldest)',
    'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Updated (newest)',
    'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Sort by updated (newest)',
    'dynamic-cards-search-page.results-sort.sort-options.label': 'Change list sorting',
    'dynamic-cards-search-page.rovo-onboarding-dismiss': 'Dismiss',
    'dynamic-cards-search-page.rovo-onboarding-done': 'Done',
    'dynamic-cards-search-page.rovo-onboarding-next': 'Next',
    'dynamic-cards-search-page.rovo-onboarding-step-1-description': 'Filter by product to get more relevant search results.',
    'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Search across all your company workspaces',
    'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
    'dynamic-cards-search-page.rovo-onboarding-step-2-description': "Depending on the product you're filtering by, these options change to help you get specific results.",
    'dynamic-cards-search-page.rovo-onboarding-step-2-heading': "Find exactly what you're looking for",
    'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
    'dynamic-cards-search-page.search-result.attachment-label': 'Attachment',
    'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Attached {formattedDate}',
    'dynamic-cards-search-page.search-result.attachments.audio-label': 'Audio',
    'dynamic-cards-search-page.search-result.attachments.expand.label': 'Expand',
    'dynamic-cards-search-page.search-result.attachments.image-label': 'Image',
    'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
    'dynamic-cards-search-page.search-result.attachments.video-label': 'Video',
    'dynamic-cards-search-page.search-result.last-modified': 'Updated {formattedDate}',
    'dynamic-cards-search-page.search-result.message-last-active': 'Last active {formattedDate}',
    'dynamic-cards-search-page.search-result.message-type-label': 'Message',
    'dynamic-cards-search-page.search-result.private-channel-label': 'Private Channel',
    'dynamic-cards-search-page.search-result.remove-recent-search': 'Remove recent search icon',
    'dynamic-cards-search-page.search-result.remove-recent-search-result-subheading': 'Recent search',
    'dynamic-cards-search-page.search-result.repository-label': 'Repository',
    'dynamic-cards-search-page.search-result.thread-title-wth-others': '{contributorCount, plural, =0 {Group message with external users} =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other} other {{name1}, {name2}, {name3}, and {overflowContributorCount} others} }',
    'dynamic-cards-search-page.search-result.thread-type-label': 'Thread',
    'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'unknown-channel',
    'dynamic-cards-search-page.search_result_type_answer': 'Answer',
    'dynamic-cards-search-page.search_result_type_attachment': 'Attachment',
    'dynamic-cards-search-page.search_result_type_blogpost': 'Blog Post',
    'dynamic-cards-search-page.search_result_type_board': 'Board',
    'dynamic-cards-search-page.search_result_type_branch': 'Branch',
    'dynamic-cards-search-page.search_result_type_calendar': 'Calendar',
    'dynamic-cards-search-page.search_result_type_card': 'Card',
    'dynamic-cards-search-page.search_result_type_channel': 'Channel',
    'dynamic-cards-search-page.search_result_type_comment': 'Comment',
    'dynamic-cards-search-page.search_result_type_commit': 'Commit',
    'dynamic-cards-search-page.search_result_type_component': 'Component',
    'dynamic-cards-search-page.search_result_type_dashboard': 'Dashboard',
    'dynamic-cards-search-page.search_result_type_database': 'Database',
    'dynamic-cards-search-page.search_result_type_document': 'Document',
    'dynamic-cards-search-page.search_result_type_embed': 'Smart Link',
    'dynamic-cards-search-page.search_result_type_filter': 'Filter',
    'dynamic-cards-search-page.search_result_type_folder': 'Folder',
    'dynamic-cards-search-page.search_result_type_goal': 'Goal',
    'dynamic-cards-search-page.search_result_type_issue': 'Issue',
    'dynamic-cards-search-page.search_result_type_learning': 'Learning',
    'dynamic-cards-search-page.search_result_type_message': 'Message',
    'dynamic-cards-search-page.search_result_type_page': 'Page',
    'dynamic-cards-search-page.search_result_type_plan': 'Plan',
    'dynamic-cards-search-page.search_result_type_presentation': 'Presentation',
    'dynamic-cards-search-page.search_result_type_project': 'Project',
    'dynamic-cards-search-page.search_result_type_pull_request': 'Pull Request',
    'dynamic-cards-search-page.search_result_type_question': 'Question',
    'dynamic-cards-search-page.search_result_type_repository': 'Repository',
    'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Sharepoint Document',
    'dynamic-cards-search-page.search_result_type_space': 'Space',
    'dynamic-cards-search-page.search_result_type_space_calendar': 'Space calendar',
    'dynamic-cards-search-page.search_result_type_spreadsheet': 'Spreadsheet',
    'dynamic-cards-search-page.search_result_type_tag': 'Tag',
    'dynamic-cards-search-page.search_result_type_unrecognised': 'Unrecognised',
    'dynamic-cards-search-page.search_result_type_whiteboard': 'Whiteboard',
    'dynamic-cards-search-page.search_result_type_work_item': 'Work Item',
    'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product': 'Your admin has added <strong>{product}!</strong>{br} Connect your account to see missing results, including documents only you have access to.',
    'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate': '<strong>{product} is now available!</strong>{br} Connect your account to see missing results, including documents only you have access to.',
    'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Authorise',
    'dynamic-cards-search-page.sidebar-oauth-warning-dismiss': 'Dismiss',
    'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Authorisation for {product} failed.',
    'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Authorisation for {product} successful.',
    'dynamic-cards-search-page.sidebar-oauth-warning.connect': 'Connect',
    'dynamic-cards-search-page.sidebar-oauth-warning.not-now': 'Not now',
    'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filter by all apps',
    'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filter by more apps',
    'dynamic-cards-search-page.team': 'Team',
    'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Archived',
    'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'At risk',
    'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Cancelled',
    'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Completed',
    'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Off track',
    'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'On track',
    'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Paused',
    'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Pending',
    'dynamic-cards-search-page.video-search-result.dropdown-message': '{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
    'dynamic-cards-search-page.video-search-result.video-icon-label': 'video icon',
    'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Video thumbnail',
    'dynamic-cards-search-page.work-item-assignee.assigned': 'is assigned',
    'dynamic-cards-search-page.work-item-creator.created': 'created',
    'dynamic-cards-search-page.work-item-project.label': 'Project',
    'dynamic-cards-search-page.work-item-status.for': 'for',
    'dynamic-cards-search-page.work-item-task.label': 'Task',
    'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
    'dynamic-cards-search-page.work-item.label': 'Work item',
    'initialsAvatar.label': 'Initials Avatar',
    'personAvatar.label': 'Person Avatar',
    'search-page.results.private-result-label': 'Private',
    'search-page.results.private-result-tooltip': 'Only visible to you',
    'search-page.results.product-results.third-party.channel-member-count': '{memberCount, plural, one {# member} other {# members}}',
    'search-page.results.product-results.third-party.channel-type-label': 'Channel',
    'search-page.results.product-results.third-party.conversation-search-result.label': 'Channel',
    'search-page.results.product-results.third-party.conversation-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'search-page.results.product-results.third-party.conversation-search-result.time-since-label': 'Last active {formattedDate}',
    'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'unknown-channel',
    'search-page.results.product-results.third-party.external-people-label': 'External people',
    'search-page.results.product-results.third-party.external-person-label': 'External person',
    'search-page.results.product-results.third-party.last-active': 'Last active {relativeDate}',
    'search-page.results.product-results.third-party.message-type-label': 'Message',
    'search-page.results.product-results.third-party.no-contributors-label': 'External people in #{channelName}',
    'search-page.results.product-results.third-party.private-conversation-text': '{users} in a private conversation',
    'search-page.results.product-results.third-party.thread-type-label': 'Thread',
    'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
    'search-page.results.product-results.third-party.title-with-remaining-contributors': '{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
    'search-page.results.restricted-result-label': 'Restricted',
    'search-page.results.restricted-result-tooltip': 'Only visible to specific people',
    'search-page.show-more-breadcrumbs-button-label': 'Show more breadcrumbs',
    'search-page.verified-icon-label': 'Verified',
    'search-page.verified-icon-tooltip-message': 'This page has been verified by an owner or admin.',
    'search-result.result.count': '{count, plural, one {Showing {count} result} other {Showing {count} results}}',
    'search-result.user-mention.external-person': 'External person'
};

});


//# sourceMappingURL=en_GB.e2d95648.js.map
